var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgHeartFill = function SvgHeartFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.755 2c-.82 0-1.633.163-2.39.48a6.24 6.24 0 00-2.026 1.365l-.34.342-.338-.342a6.219 6.219 0 00-4.416-1.844 6.218 6.218 0 00-4.416 1.844A6.325 6.325 0 001 8.298c0 1.67.658 3.273 1.83 4.454L12 22l9.17-9.248a6.3 6.3 0 001.354-2.043 6.342 6.342 0 00-1.354-6.864 6.24 6.24 0 00-2.025-1.365 6.198 6.198 0 00-2.39-.48z",
    fill: "currentColor"
  })));
};
export default SvgHeartFill;